import { brandLogos, type BrandLogo } from './brandLogos'

/**
 * Curated subset of brand logos featured in the SocialProof marquee.
 * The full 138-brand catalog lives in `brandLogos.ts`.
 *
 * Pick rule of thumb: the most recognizable names spread across all 7
 * sectors so the strip reads as "we work with everyone" at a glance.
 * To swap brands in/out, edit the slug list and re-render — no asset
 * moves needed since all 138 are already in public/clients/.
 */
// Two constraints for picking entries:
//   1. Avoid JPG-sourced wrappers — the card silhouettes each logo and
//      a JPG (no alpha) renders as a solid black rectangle. nestle was
//      pulled for this; re-add only after a transparent replacement.
//   2. Avoid brand marks that are themselves a solid colored tile (the
//      "!" tile that the Snapp family ships) — even in grayscale they
//      read as a flat box, breaking the silhouette strip. Snapp's own
//      tile is kept because the user explicitly wanted it surfaced;
//      snappfood / snappdoctor / tipax were dropped for being either
//      tile-shaped or so tiny (15–16px source) they render as nothing.
const FEATURED_SLUGS = [
  // Tech / consumer
  'snapp',
  'divar',
  'filimo',
  'alibaba',
  'jajiga',
  // Fintech
  'digipay',
  'bitpin',
  'nobitex',
  'blu-bank',
  // FMCG
  'kaleh',
  'unilever',
  'henkel',
  'hyperstar',
  // Services
  'classino',
] as const

const bySlug = new Map<string, BrandLogo>(brandLogos.map((b) => [b.slug, b]))

/** Featured brands in marquee order; quietly drops any slug whose asset is missing. */
export const clients = FEATURED_SLUGS.map((slug) => bySlug.get(slug)).filter(
  (b): b is BrandLogo => b !== undefined,
)

export type Client = BrandLogo
